export default __webpack_public_path__ + "static/media/favicon.882fc6ee.jpeg";